import { Brand } from 'effect'

type ParcelId = string & Brand.Brand<'CursorId'>

const ParcelId = {
  make: Brand.nominal<ParcelId>(),
}

export default ParcelId
